








































































































































































import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import moment from "moment";
import { i18n } from "@/resources/locales";
@Component({
  name: "announcements-component",
})
export default class AnnouncementsComponent extends mixins(NotificationEvent) {
  [x: string]: any;
  @Prop({ default: true }) isCampus;
  openModal = false;
  openConfirmDeleteModal = false;
  title = "";
  text = "";
  time = moment().add("5", "m").format("HH:mm");
  frequency = "PUNCTUAL";
  loader = true;
  announcements = [];
  loadingDelete = false;
  selectToDelete = -1;
  repeat = false;
  progranNotificacionCampus = false;
  /*get superSpace(): any {
    return this.$store.getters["SuperSpaceStore/getSuperSpace"];
  }*/
  mounted() {
    this.progranNotificacionCampus = this.isCampus;
    if (localStorage.getItem("open_modal_active") == "active") {
      if (localStorage.getItem("isCampus") == "true") {
        this.progranNotificacionCampus = true;
      } else {
        this.progranNotificacionCampus = false;
      }
    }
    this.showAnnoucements();
  }
  destroyed(): void {
    localStorage.removeItem("isCampus");
    localStorage.removeItem("open_modal_active");
  }
  checkText() {
    if (localStorage.getItem("isCampus") == "true")
      return this.$i18n.t("announcements.text1");
    else if (localStorage.getItem("isCampus") == "false") {
      return this.$i18n.t("announcements.text2");
    }
  }
  momentDate(date) {
    return moment(date).format("yyyy-MM-DD HH:mm");
  }
  isValidDate(): boolean {
    return moment(this.time).isValid();
  }
  getTime() {
    return this.time.length > 5 ? true : false;
  }
  get getCampus(): boolean {
    return this.$store.getters["AnnouncementsStore/getCampus"];
  }
  saveAnnouncement() {
    this.openModal = false;
    let space = this.loadSpace();
    this.$store.dispatch("AnnouncementsStore/saveAnnoucementAction", {
      type: this.progranNotificacionCampus ? "super_space" : "space",
      id: this.progranNotificacionCampus ? space.superSpace.id : space.id,
      data: {
        title: this.title,
        text: this.text,
        time: moment(this.time).utc().format("yyyy-MM-DD HH:mm:ss"),
        frequency: this.repeat ? "REPEAT" : "PUNCTUAL", //this.frequency === " " ? null : this.frequency, //Todo hasta que se modifique.
      },
      callback: (response) => {
        this.title = "";
        this.text = "";
        this.time = moment().format("HH:mm");
        //this.frequency = " ";
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("announcements.successCreate")
        );
        this.showAnnoucements();
      },
    });
  }

  showAnnoucements() {
    let space = this.loadSpace();
    this.$store.dispatch("AnnouncementsStore/getAnnouncementsAction", {
      type: this.progranNotificacionCampus ? "superSpace" : "space",
      id: this.progranNotificacionCampus ? space ? space.superSpace.id : this.superSpace.id : space ?  space.id : this.$route.params.id,
      callback: (response) => {
        this.loader = false;
        this.announcements = response.data;
      },
    });
  }
  deleteAnnouncement() {
    this.$store.dispatch("AnnouncementsStore/deleteAnnouncementAction", {
      id: this.selectToDelete,
      callback: (response) => {
        this.selectToDelete = -1;
        this.openConfirmDeleteModal = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("announcements.successDelete")
        );
        this.showAnnoucements();
      },
    });
  }
  loadSpace() {
    let space = this.$store.getters["SpaceStore/getSpace"];
    let selectedSapceCustomize =
      this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (selectedSapceCustomize) {
      space = selectedSapceCustomize;
    }
    return space;
  }
}
